<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <div class="watermark">
            <img v-if="saleInvoice?.branch?.company?.watermark && invoiceHeader" :src="getFileServerUrl + saleInvoice?.branch?.company?.watermark" alt="">
          </div>

          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="saleInvoice?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <img :src="`${getFileServerUrl}${saleInvoice?.branch?.company?.header_image}`" style="width: 100%;" alt="">
                    </td>
                  </tr>
                </thead>
                
                <tbody>
                  <!-- Header Section -->
                  <tr v-if="!saleInvoice?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <div class="page-header">
                        <div class="header-section d-flex justify-space-between align-start">
                          <div class="company-info">
                            <h4 class="company-name">{{ saleInvoice?.branch?.company?.name || '' }}</h4>
                            <p class="company-text">{{ saleInvoice?.branch?.company?.address || '' }}</p>
                            <p class="company-text">
                              <v-icon size="small">mdi-phone-outline</v-icon>
                              {{ saleInvoice?.branch?.company?.mobile || '' }}
                            </p>
                            <p class="company-text">
                              <v-icon size="small">mdi-email-outline</v-icon>
                              {{ saleInvoice?.branch?.company?.email || '' }}
                            </p>
                          </div>
                          <div class="logo-container">
                            <v-img
                              :src="`${getFileServerUrl}/${saleInvoice?.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                              max-width="150"
                              max-height="70"
                              contain
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  
                  <!-- Invoice Details Section -->
                  <tr>
                    <td colspan="100%">
                      <div class="header-table" style="font-size: 12px; margin-top: 10px;">
                        
                        <div style="display: flex; justify-content: center;">
                          <h1 style="font-size: 16px; text-decoration: underline;">Invoice</h1>
                        </div>
                        <div>
                          <strong>{{ formatDateView(new Date) }}</strong><br/>
                          To, <br>
                          <strong>{{ saleInvoice?.customer?.company_name }}</strong><br/>
                          <strong>{{ saleInvoice?.customer?.company_address}}</strong><br>
                        </div>

                        <!-- FIXED: Attention + Invoice info side by side, print-safe -->
                        <div style="margin-top: 10px; margin-bottom: 10px; display: flex; justify-content: space-between; width: 100%;">
                          <div>
                            <template v-if="saleInvoice?.customer?.contacts?.[0]">
                              <p><strong>Attention:</strong> {{ saleInvoice?.customer?.contacts?.[0]?.name }}</p>
                              <p><strong>Contact no:</strong> {{ saleInvoice?.customer?.contacts?.[0]?.mobile }}</p>
                            </template>
                          </div>
                          <div>
                            <p><strong>Invoice No:</strong> {{ saleInvoice?.code }}</p>
                            <p><strong>Invoice Date:</strong> {{ formatDateView(saleInvoice?.sale_order_date) }}</p>
                            <p><strong>PO No:</strong> {{ saleInvoice?.po_no }}</p>
                          </div>
                        </div>

                        <div style="margin-top: 10px; margin-bottom: 10px;">
                          <strong>Subject: <span style="text-decoration: underline;">Payment of Bill</span></strong><br/>
                        </div>
                          
                        <div style="width: 100%;">
                          <div>
                            <p><span style="font-weight: bold;">Ref:</span> Your purchase order no. {{ saleInvoice?.po_no }} Date: {{ saleInvoice?.po_date }}</p><br/>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <!-- Details table -->
                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="dep-table details-table" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">SN</th>
                            <th style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">Code</th>
                            <th style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">Item Detils</th>
                            <th style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">Lot No.</th>
                              <th style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">Unit</th>
                            <th style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">Qty.</th>
                            <th v-if="isFreeItem" style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">Free Qty.</th>
                          
                            <th style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">Rate</th>
                            <th style="border: 1px solid #E0E0E0; padding: 2px; font-size: 12px;">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                           <template v-for="(row, idx) in saleInvoice?.details" :key="idx">
                          <tr>
                            <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: center;">{{ idx + 1 }}</td>
                            <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: center;">{{ row.product?.code }}</td>
                            <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: left;">{{ row.product?.name }}</td>
                            <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: center;">{{ row.lot_no }}</td>
                             <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: center;">{{ row.product?.unit?.name }}</td>
                            <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: center;">{{ row.qty }}</td>
                            <td v-if="isFreeItem" style="border: 1px solid #E0E0E0; padding: 2px; text-align: center;">{{ row.free_qty }}</td>
                           
                            <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ row.sale_rate }}</td>
                            <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ row.total }}</td>
                          </tr>

                             <!-- 🎁 Gift Rows -->
                                <tr v-for="(gift, gIdx) in row.gifts || []"
                                    :key="'gift-'+idx+'-'+gIdx">

                                  <td style="border:1px solid #E0E0E0; text-align:center;"></td>

                                 <td style="border:1px solid #E0E0E0; text-align:center;">{{ gift.product?.code }}</td>

                                  <td style="border:1px solid #E0E0E0; text-align:left;">
                                    🎁 {{ gift.product?.name }}
                                  </td>

                                  <td style="border:1px solid #E0E0E0; text-align:center;"></td>
                              
                                  <td style="border:1px solid #E0E0E0; text-align:center;">
                                    {{ gift.product?.unit?.name }}
                                  </td>

                                  <td style="border:1px solid #E0E0E0; text-align:center;">
                                    {{ gift.qty }}
                                  </td>

                                  <td style="border:1px solid #E0E0E0; text-align:center;">0</td>

                                  <td style="border:1px solid #E0E0E0; text-align:right;">{{ gift.sale_rate }}</td>

                                  <td style="border:1px solid #E0E0E0; text-align:right;">{{ gift.total }}</td>

                                </tr>


                          </template>
                          
                        </tbody>
                        <tfoot>
                            <tr>
                            <td colspan="100%" style="border: none;">
                              <table style="width: 100%; border-collapse: collapse; font-size: 12px;text-align: end; margin-top: 0px !important;">
                                <tbody>
                                  <tr>
                                    <td style="border: 1px solid #E0E0E0; padding: 2px; width: 86%; border-top: none !important;"><strong>SUBTOTAL</strong></td>
                                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right; border-top: none !important;">{{ saleInvoice?.sub_total }}</td>
                                  </tr>
                                  <tr>
                                    <td style="border: 1px solid #E0E0E0; padding: 2px;"><strong>DISCOUNT</strong></td>
                                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ saleInvoice?.discount_amount }}</td>
                                  </tr>
                                  <tr>
                                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-transform: capitalize;"><strong>VAT ({{ saleInvoice?.vat_type }})</strong></td>
                                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ saleInvoice?.vat_amount > 0 ? saleInvoice?.vat_amount : '-' }}</td>
                                  </tr>
                                  <tr>
                                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-transform: capitalize;"><strong>TAX ({{ saleInvoice?.tax_type }})</strong></td>
                                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ saleInvoice?.tax_amount > 0 ? saleInvoice?.tax_amount : '-' }}</td>
                                  </tr>
                                  <tr>
                                    <td style="border: 1px solid #E0E0E0; padding: 2px;"><strong>PAID</strong></td>
                                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ saleInvoice?.paid }}</td>
                                  </tr>
                                  <tr>
                                    <td style="border: 1px solid #E0E0E0; padding: 2px;"><strong>DUE</strong></td>
                                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ saleInvoice?.due }}</td>
                                  </tr>
                                  <tr style="background-color: #f0f0f0;">
                                    <td style="border: 1px solid #E0E0E0; padding: 2px; font-weight: bold;"><strong>TOTAL</strong></td>
                                    <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right; font-weight: bold;">{{ saleInvoice?.total }}</td>
                                  </tr>
                                </tbody>
                              </table>
        
                              <div style="font-size: 12px; display: flex; margin-top: 20px;">
                                <p style="text-align: start;"><strong>In words: </strong></p>
                                <p style="text-align: start;">{{ convertNumberToWords(saleInvoice?.sub_total) }}</p>
                              </div>
        
                              <div style="font-size: 12px; display: flex; margin-top: 5px;">
                                <p style="text-align: start;"><strong>Mode of payment: </strong></p>
                                <p style="text-align: start;"> by A/C payee cheque in favour of "{{ saleInvoice?.branch?.company?.name }}"</p>
                              </div>
                                  
                              <div style="font-size: 12px; margin-top: 5px; background-color: #ffffff;">
                                <p><strong>Payment Terms: </strong></p>
                                <p>{{ saleInvoice?.sale_order?.payment_terms || '-' }}</p>
                              </div>
                              <div v-if="saleInvoice?.payment_bank" style="font-size: 12px; margin-top: 5px; background-color: #ffffff;">
                                <p><strong>Wire Transfer to following bank account: </strong></p>
                                <table style="border-collapse: collapse;">
                                  <tbody >
                                    <tr>
                                      <td style="border:none; width: 200px;">Account Name</td>
                                      <td style="border:none;">:{{  saleInvoice?.payment_bank?.account_name? `${saleInvoice?.payment_bank?.account_name}`: ""  }}</td>
                                    </tr>
                                    <tr>
                                      <td style="border:none;">Account Number</td>
                                      <td style="border:none;">:{{ saleInvoice?.payment_bank?.account_no? `${saleInvoice?.payment_bank?.account_no}`: ""  }}</td>
                                    </tr>
                                    <tr>
                                      <td style="border:none;">Name of the Bank</td>
                                      <td style="border:none;">:{{ saleInvoice?.payment_bank?.name? `${saleInvoice?.payment_bank?.name}`: ""  }}</td>
                                    </tr>
                                    <tr>
                                      <td style="border:none;">Branch Name</td>
                                      <td style="border:none;">:{{ saleInvoice?.payment_bank?.branch? `${saleInvoice?.payment_bank?.branch}`: ""  }}</td>
                                    </tr>
                                    <tr>
                                      <td style="border:none;">Swift Code</td>
                                      <td style="border:none;">:{{ saleInvoice?.payment_bank?.swift_code? `${saleInvoice?.payment_bank?.swift_code}`: ""  }}</td>
                                    </tr>
                                    <tr>
                                      <td style="border:none;">Routing No.</td>
                                      <td style="border:none;">:{{ saleInvoice?.payment_bank?.routing_no? `${saleInvoice?.payment_bank?.routing_no}`: ""  }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </td>
                  </tr>

                  <!-- Signatures -->
                  <tr>
                    <td colspan="100%" class="details-table" style="border: none;">
                      <div style="margin-top: 10px;">
                        <div style="display: flex; width: 100%; padding: 0 12px;">
                          <div style="flex: 0 0 50%; max-width: 50%; text-align: center; padding: 2px 12px; box-sizing: border-box;">
                            <div style="border-bottom: 1px solid #000; margin: 50px 0 8px 0; height: 20px;"></div>
                            <div style="text-transform: uppercase; font-weight: bold; font-size: 12px;">RECEIVER'S SIGNATURE</div>
                          </div>
                          <div style="flex: 0 0 50%; max-width: 50%; text-align: center; padding: 2px 12px; box-sizing: border-box;">
                            <div style="border-bottom: 1px solid #000; margin: 50px 0 8px 0; height: 20px;"></div>
                            <div style="text-transform: uppercase; font-weight: bold; font-size: 12px;">AUTHORIZED SIGNATURE</div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%;height: 100px;">&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer">
              <img v-if="saleInvoice?.branch?.company?.footer_image && invoiceHeader" :src="`${getFileServerUrl}${saleInvoice?.branch?.company?.footer_image}`" alt="" style="width: 100%; display: block;">
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Button -->
    <v-row justify="end" class="d-print-none mt-4 ">
      <v-col cols="12"  justify="center" style="display:flex; justify-content: center;">
          <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
            Print without pad
          </v-btn>
          <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
            Print with pad
          </v-btn>
      </v-col>
    </v-row>

  </v-container>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import convertNumberToWords from "@/plugins/numberToWord";
import { formatDateView, formatDateDash } from "@/plugins/helpers";
import { getCompanyInfo } from '@/plugins/helpers'

const route = useRoute();
const store = useStore();

const saleInvoice = ref();
const pagePadding = ref(0);
const invoiceHeader = ref(true);
const isGiftItem = ref(false);
const isFreeItem = ref(false);

const getFileServerUrl = computed(() => store.getters.getFileServerUrl);

const print = (isPad) => {

  if (isPad === 1) {
    invoiceHeader.value = true;
    pagePadding.value = 0;
  } else if (isPad === 0) {
    invoiceHeader.value = false;
    pagePadding.value = 100;
  }

  setTimeout(() => {

    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);
  
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Invoice</title>
      <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
  
        @page {
          size: A4;
          margin: ${pagePadding.value}px 0;
        }
  
        html, body {  
          margin: 0 ;
          padding: 0; 
          width: 100%;
          height: auto;
        }
  
        body { 
          font-family: sans-serif; 
          background:#fff; 
          color:#000; 
          -webkit-print-color-adjust: exact; 
          print-color-adjust: exact;
          margin: 0;
          padding: 0;
        }
  
        .report-paper { 
          width: 100%; 
          padding: 0 !important;
          background: #fff;
          margin: 0;
        }
  
        .invoice-container {
          width: 100%;
          margin: 0;
          padding: 0;
        }

        .header-table {
          padding: 0 32px;
        }
  
        .invoice-content {
          width: 100%;
          margin: 0;
          padding: 0;
          overflow: visible;
        }
  
        header img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
  
        table {
          width: 100%;
          margin: 0;
          padding: 0;
        }

        .details-table {
          padding: 0px 32px;
        }
  
        footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 10;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        footer img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
  
        .page-header {
          margin-bottom: 20px;
          padding: 20px 0;
        }
  
        .header-section { 
          display: flex; 
          justify-content: space-between; 
          align-items: flex-start; 
          border-bottom: 2px solid #eee; 
          padding-bottom: 10px; 
          margin-bottom: 16px; 
        }
  
        .company-name { 
          font-size: 12px; 
          font-weight: bold; 
          text-transform: uppercase; 
          margin: 0 0 4px 0; 
        }
  
        .company-text { 
          font-size: 12px; 
          margin: 2px 0; 
          display: flex; 
          align-items: center; 
        }
  
        .logo-container img { 
          max-height: 70px; 
          max-width: 150px; 
        }
  
        .report-title { 
          font-size: 16px; 
          text-align: center; 
          margin: 8px 0; 
        }
  
        .watermark {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 0;
        }
  
        table { 
          width: 100% !important; 
          border-collapse: collapse; 
          font-size: 12px; 
          margin: 8px 0;
          background: white;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        th, td { 
          border: none; 
          padding: 0; 
          vertical-align: middle; 
        }
  
        th { 
          background: #e0e0e0; 
          text-align: center; 
          font-weight: bold;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        .master-box-parent {
          border: none !important;
          page-break-inside: avoid;
        }
  
        .master-box {
          margin: 16px 0;
          page-break-inside: avoid;
        }
  
        .invoice-content {
          page-break-inside: avoid;
        }
  
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .text-left { text-align: left; }
        
        table {
          page-break-inside: avoid;
          orphans: 3;
          widows: 3;
        }
        
        tr {
          page-break-inside: avoid;
        }
        .mt-4 { 
          margin-top: 0px !important;
          margin-left: -10px !important;
          margin-right: -10px !important;
        }
        .mt-5 { 
          margin-top: 5px !important;
          margin-left: 0px !important;
          margin-right: 0px !important;
        }
        .mt-8 { margin-top: 0px !important; }
        .my-6 { margin-top: 0px !important; margin-bottom: 0px !important; }
  
        img { 
          max-width: 100% !important; 
          height: auto !important; 
        }
  
        .d-flex { display: flex; }
        .justify-space-between { justify-content: space-between; }
        .align-start { align-items: flex-start; }

        /* FIXED: Replace Vuetify v-row/v-col with plain flex for print */
        .v-row { 
          display: flex !important; 
          flex-wrap: wrap !important; 
          margin: 0;
          width: 100%;
        }
  
        .v-col-6 { 
          flex: 0 0 50% !important; 
          max-width: 50% !important; 
          padding: 0 12px 12px 12px;
          box-sizing: border-box;
          margin: 0;
        }
  
        .pa-6 { padding: 0 !important; }
  
        .order-table thead {
          display: table-header-group;
          page-break-inside: avoid;
        }
  
        .order-table tbody {
          page-break-inside: avoid;
        }
  
        div[style*="margin-top"], div[style*="padding"] {
          page-break-inside: avoid;
        }
  
        .order-table tbody tr {
          page-break-inside: avoid;
        }
  
        .signature-box {
          font-size: 12px;
          border: 1px solid black;
          border-radius: 5px;
          padding: 10px;
        }
  
        .signature-line {
          border-bottom: 1px solid #000;
          margin: 50px 0;
          height: 30px;
        }
  
        .signature-label {
          text-transform: uppercase;
          font-weight: bold;
          font-size: 12px;
        }
  
        .invoice-container {
          display: flex;
          flex-direction: column;
        }
  
        .invoice-content {
          flex: 1;
          overflow: visible;
          margin-top: -10px;
        }
          
        .company-info {
          flex: 1;
        }
  
        .invoice-footer {
          margin-top: auto;
          position: fixed;
          left: 0;
          bottom: 0px;
          width: 100%;    
        }
  
        @media print { 
          body {
            margin: 0;
            padding: 0;
          }
  
          .report-paper {
            margin: 0;
            padding: 0;
          }
  
          main {
            padding-top: 180px;
            padding-bottom: 150px;
            padding-left: 20px;
            padding-right: 20px;
          }
            
          .order-table {
            page-break-inside: auto;
          }
  
          .order-table tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
  
          .order-table thead {
            display: table-header-group;
          }
        }
      </style>
      </head>
      <body>
        ${printContent}
      </body>
      </html>
    `);
  
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
    invoiceHeader.value = true;
    pagePadding.value = 0;
  }, 500)

};

onMounted(() => {
  const id = route.params.id;
  store.dispatch('getSaleInvoiceById', id)
    .then((res) => {
      saleInvoice.value = res;
      console.log(saleInvoice.value);
    })
    isGiftItem.value = getCompanyInfo()?.is_gift_item ?? false;
    isFreeItem.value = getCompanyInfo()?.is_free_item ?? false;
})
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 12px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 12px; }
.report-title { font-size: 16px; text-align: center; margin: 8px 0; }
.meta-box { border: 1px solid #000; padding: 2px; font-size: 12px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 2px; font-size: 12px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.d-print-none {
  display: block !important;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>